import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// import AppHome from '@/components/common/AppHome'
import AppLogin from '@/components/common/AppLogin'
import About from '@/components/common/About'
import AppProduct from '@/components/common/AppProduct'
import AppPurchase from '@/components/customer/AppPurchase'
import AppProfile from '@/components/customer/AppProfile'
import HomeInguz from '@/components/common/HomeInguz'
import SignUp from '@/components/common/SignUp'

import SignUpCommon from '@/components/common/SignUpCommon'
import Forgotpassword from '@/components/common/Forgotpassword'
import SignUpSeller from '@/components/common/SignUpSeller'
import firstpage from '@/components/common/firstpage'
import ForgotPasswordChange from '@/components/common/ForgotPasswordChange'
import AddProduct from '@/components/common/AddProduct'
import ImageUpload from '@/components/common/ImageUpload'
import AddShipping from '@/components/common/AddShipping'
import PlaceOrder from '@/components/common/PlaceOrder'
// import Payment from '@/components/common/Payment'
import sample from '@/components/common/sample'
import HomePage from '@/components/common/HomePage'
import ProductList from '@/components/common/ProductList'
import ProductView from '@/components/common/ProductView'
import EditProduct from '@/components/common/EditProduct'
import Pending from '@/components/common/Pending'
import Sellercomponent from '@/components/common/Sellercomponent'
import SellerDashboard from '@/components/common/SellerDashboard'
import ClientList from '@/components/common/ClientList'
import SellerImage from '@/components/common/SellerImage'
import SellerPurchase from '@/components/common/SellerPurchase'
import orderlist from '@/components/common/orderlist'
import wishlist from '@/components/common/wishlist'
import AddTrackingId from '@/components/common/AddTrackingId'
import checkout from '@/components/common/checkout'
Vue.use(Router)

let router = new Router({
	mode:'history',
	routes: [
		{
			path: '/',
			name: 'HomeInguz',
			component: HomeInguz,
			
		},
		{
			path: '/Sellercomponent',
			name: 'Sellercomponent',
			component: Sellercomponent,
			meta: { requiresAuth: true }
		},
		{
			path: '/SellerImage/:id',
			name: 'SellerImage',
			component: SellerImage,
			props:true,
			
		},
		{
			path: '/AddTrackingId/:id',
			name: 'AddTrackingId',
			component: AddTrackingId,
			props:true,
			
		},
		{
			path: '/checkout/:id',
			name: 'checkout',
			component: checkout,
			props:true,
			
		},
		{
			path: '/SellerDashboard',
			name: 'SellerDashboard',
			component: SellerDashboard,
			meta: { requiresAuth: true }
		},
		{
			path: '/ClientList',
			name: 'ClientList',
			component:ClientList,
			meta: { requiresAuth: true }
		},
		{
			path: '/About/:id',
			name: 'About',
			component: About,
			props:true,
			meta: { requiresAuth: true }
		},
		{
			path: '/HomePage',
			name: 'HomePage',
			component: HomePage,
			
		},
		{
			path: '/Pending',
			name: 'Pending',
			component: Pending,
			meta: { requiresAuth: true }
		},
		{
			path: '/EditProduct/:id',
			name: 'EditProduct',
			component: EditProduct,
			props:true,
			meta: { requiresAuth: true }
			
		},
		{
			path: '/ProductView/:id',
			name: 'ProductView',
			component: ProductView,
			props:true,
			meta: { requiresAuth: true }
		},
		{
			path: '/ProductList',
			name: 'ProductList',
			component:ProductList,
			meta: { requiresAuth: true }
		},
		{
			path: '/sample',
			name: 'sample',
			component: sample,
			meta: { requiresAuth: true }
		},
		{
			path: '/PlaceOrder/:id',
			name: 'PlaceOrder',
			component: PlaceOrder,
			props:true,
			meta: { requiresAuth: true }
		},
		{
			path: '/ImageUpload/:id',
			name: 'ImageUpload',
			component: ImageUpload,
			props:true,
			meta: { requiresAuth: true }
		},
		{
			path: '/AddShipping/:id',
			name: 'AddShipping',
			component: AddShipping,
			props:true,
			meta: { requiresAuth: true }
		},
		{
			path: '/AddProduct',
			name: 'AddProduct',
			component: AddProduct,
			meta: { requiresAuth: true }
		},
		{
			path: '/firstpage',
			name: 'firstpage',
			component:firstpage,
			meta: { requiresAuth: true }
			
		},
		{
			path: '/ForgotPasswordChange',
			name: 'ForgotPasswordChange',
			component:ForgotPasswordChange,
		},
		{
			path: '/SignUpSeller',
			name: 'SignUpSeller',
			component: SignUpSeller,
			
		},
		{
			path: '/SellerPurchase',
			name: 'SellerPurchase',
			component: SellerPurchase,
			props:true,
			meta: { requiresAuth: true }
			
		},
		{
			path: '/Forgotpassword',
			name: 'Forgotpassword',
			component: Forgotpassword,
		},
		{
			path: '/orderlist',
			name: 'orderlist',
			component: orderlist,
			meta: { requiresAuth: true }
		},
		{
			path: '/wishlist/:id',
			name: 'wishlist',
			component: wishlist,
			props:true,
			meta: { requiresAuth: true }
		},
		
		{
			path: '/SignUp',
			name: 'SignUp',
			component:SignUp,
			
		},
		{
			path: '/SignUpCommon',
			name: 'SignUpCommon',
			component:SignUpCommon,
			
		},
		// {
		// 	path: '/HomeInguz/:id',
		// 	name: 'HomeInguz',
		// 	component: HomeInguz,
		// 	props:true,
			
		// },
		{
			path: '/Product/:id',
			name: 'Product',
			component: AppProduct,
			props: true,
			
		},
		
		{
			path: '/AppLogin',
			name: 'AppLogin',
			component: AppLogin,
			
		},
		{
			path: '/Purchase/:id',
			name: 'Purchse',
			component: AppPurchase,
			props: true,
			meta: { requiresAuth: true }
		},
		{
			path: 'Profile',
			name: 'Profile',
			component: AppProfile,
			meta: { requiresAuth: true }
		}
	]

})
router.beforeEach((to, from, next) => {

	
	if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
	  next({ name: 'AppLogin' })
	  return
	}
	if (to.path === '/SignUp' && store.state.isLoggedIn ) {
		next({ name: 'firstpage' })
		return
	  }
	if (to.path === '/AppLogin' && store.state.isLoggedIn ) {
		next({ name: 'firstpage' })
		return
	  }
	
	
	next()
  })

export default router